<template>
	<div>
		<div class="scroll-option-container">
			<span
				v-for="section in data"
				:key="section.title"
				@click="scrollTo(section.title)"
				class="scroll-options"
			>{{ section.title }}</span>
		</div>
		<i class="mdi mdi-format-vertical-align-top up-arrow" @click="goTop" />
	</div>
</template>

<script>
export default {
	props: ["data"],
	methods: {
		scrollTo(target) {
			const options = {
				duration: 300,
				offset: 50,
				easing: "easeInOutCubic"
			};
			this.$vuetify.goTo(`#${target.replace(/\s/gi, "-")}`, options);
		},
		goTop() {
			const options = {
				duration: 300,
				offset: 0,
				easing: "easeInOutCubic"
			};
			this.$vuetify.goTo("body", options);
		}
	}
};
</script>

<style lang="scss">
.scroll-option-container {

	.scroll-options {
		padding: 10px 10px;
		border-radius: 5px;
		cursor: pointer;
		color: rgb(153, 27, 30);
		line-height: 30px;
		transition: all 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
		display: inline-block;

		&:hover {
			box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
				0 4px 6px -2px rgba(0, 0, 0, 0.05);
		}
	}
}

.up-arrow {
	position: fixed;
	top: 50vh;
	right: 10%;
	transform: translateY(-50%);
	font-size: 40px;
	cursor: pointer;
	color: rgb(153, 27, 30);
	transition: color 0.3s ease-in-out;

	// temporarily display none
	display: none;

	&:hover {
		color: mediumaquamarine;
	}
}

/**
 * following are responsive support
 */
@media (max-width: 420px) {
	.scroll-option-container {
		position: relative;
		top: 0;
		right: 0;

		.scroll-options {
			padding: 0 10px;
			display: inline-block;

			&:hover {
				box-shadow: none;
			}
		}
	}
}
</style>